module.exports = __webpack_public_path__ + "img/public/SiteIcons/Group 42677.svg?af2723ec";